import { Transition } from "../../../core/flows/Transition";
import { UpcomingPastBookingContext } from "../../UpcomingPastBooking/Context/UpcomingPastBookingContext";
import { AfterSaleBookingContext } from "../Context/AfterSaleBookingContext";

export class AfterSaleBookingTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {        
        const context = this.getCtx<AfterSaleBookingContext>("afterSaleBookingContext", this.entryStep);
        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (context.routeTo.includes("UpcomingPastBookingFlow")) {
            const upcomingPastBookingContext = new UpcomingPastBookingContext()
            this.setCtx<UpcomingPastBookingContext>("upcomingPastBookingContext", upcomingPastBookingContext, this.entryStep)
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }
        return [...(context?.routeTo ?? [])]
    }

}